"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioCreationStatusToJSON = exports.AudioCreationStatusFromJSONTyped = exports.AudioCreationStatusFromJSON = exports.AudioCreationStatus = void 0;
/**
 * Describes the asset status in more detail. Only relevant when ad is being mixed through Spotify Ad Manager (SAM).
 * @export
 */
exports.AudioCreationStatus = {
    ScriptReady: 'SCRIPT_READY',
    VoiceoverApproved: 'VOICEOVER_APPROVED',
    VoiceoverFailed: 'VOICEOVER_FAILED',
    VoiceoverProcessing: 'VOICEOVER_PROCESSING',
    VoiceoverReady: 'VOICEOVER_READY',
    VoiceoverRejected: 'VOICEOVER_REJECTED',
    WaitingScriptApproval: 'WAITING_SCRIPT_APPROVAL',
    WaitingScriptRevision: 'WAITING_SCRIPT_REVISION',
    WaitingScript: 'WAITING_SCRIPT',
    WaitingVoiceoverApproval: 'WAITING_VOICEOVER_APPROVAL',
    WaitingVoiceoverRevision: 'WAITING_VOICEOVER_REVISION',
    WaitingVoiceover: 'WAITING_VOICEOVER'
};
function AudioCreationStatusFromJSON(json) {
    return AudioCreationStatusFromJSONTyped(json, false);
}
exports.AudioCreationStatusFromJSON = AudioCreationStatusFromJSON;
function AudioCreationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudioCreationStatusFromJSONTyped = AudioCreationStatusFromJSONTyped;
function AudioCreationStatusToJSON(value) {
    return value;
}
exports.AudioCreationStatusToJSON = AudioCreationStatusToJSON;
